<ng-template #leftPanel>
    <div
        class="contentGrid input-grid-gaps w-full"
        [class.contentGrid-splitter]="useSplitter()"
    >
        <app-work-detail-select-service
            (selectedService)="selectService($event)"
            [preselected]="formData().serviceId || store.globalGlobalStore.loggedUserStore.selectedServiceId()"
            [workType]="WorkTypeEnum.OPERATIONAL_WORK"
            [allowedTypes]="[ServiceTypeEnum.SOCIAL]"
            [required]="true"
        ></app-work-detail-select-service>

        <app-users-select
            [formField]="formDef.userIds"
            [serviceId]="formData().serviceId"
            label="workData.operationalWorks.fields.users"
        ></app-users-select>

        <app-date-input
            [formField]="formDef.dateFrom"
            [showTime]="true"
            label="workData.operationalWorks.fields.dateFrom"
        ></app-date-input>

        <app-number-input
            [formField]="formDef.duration"
            label="workData.operationalWorks.fields.duration"
        ></app-number-input>

        <app-date-input
            [value]="formData().dateTo"
            [showTime]="true"
            [disabled]="true"
            label="workData.operationalWorks.fields.dateTo"
        ></app-date-input>

        <app-text-input
            class="fr-full"
            [formField]="formDef.name"
            label="workData.operationalWorks.fields.name"
        ></app-text-input>

        @if (formData().serviceId) {
            <app-social-service-select-offer
                class="fr-full"
                [serviceId]="formData().serviceId"
                [date]="formData().dateFrom"
                [allowedTypes]="[SocialServiceOperationEnum.OPERATIONAL]"
                [additionalFilter]="offerAdditionalFilter"
                [defaultUsers]="formData().userIds"
                [preselectedOffers]="preselectedOffers()"
                [enableNoRecordOffers]="false"
                [unassignedOperations]="unassignedOperations"
                (selectionChange)="setOffers($event)"
                id="offers"
                label="workData.operationalWorks.fields.offers"
            ></app-social-service-select-offer>
        }

        @if (formData().serviceId) {
            <div class="fr-full">
                <app-service-pattern-wysiwyg
                    [form]="descriptionForm"
                    [serviceId]="formData().serviceId!"
                    [usage]="ServicePatternStructureUsageEnum.OPERATIONAL_WORK"
                    (addedPattern)="addPattern($event.content)"
                    id="description"
                    editorKey="WorkOperationalWork"
                    placeholder="workData.operationalWorks.fields.description"
                ></app-service-pattern-wysiwyg>
            </div>
        }

        <app-file-upload-box
            class="fr-full"
            [multiple]="true"
            [existingFiles]="existingFileIds()"
        ></app-file-upload-box>

        <app-action-buttons
            class="pt-3 fr-full"
            [primaryButtonLoading]="store.loadingAny()"
            (primaryClickEvent)="save()"
            (secondaryClickEvent)="close()"
        ></app-action-buttons>
    </div>
</ng-template>

<ng-template #rightPanel>
    <div class="displayGrid p-3 w-full">
        <app-button
            class="fr-first justify-self-end"
            icon="pi-times"
            [outlined]="true"
            (clickEvent)="useSplitter.set(false)"
        ></app-button>
        <div class="flex align-items-start fr-first">
            @if (existingWork()) {
                <app-card-content
                    [work]="$any(existingWork())"
                    [inSplitter]="true"
                    (copyTextToForm)="descriptionForm.patchValue({ description: $event })"
                ></app-card-content>
            }
        </div>
    </div>
</ng-template>

@if (useSplitter()) {
    <app-splitter
        [fullHeight]="true"
        [panelSizes]="[60, 40]"
    >
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="leftPanel"></ng-container>
        </ng-template>
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="rightPanel"></ng-container>
        </ng-template>
    </app-splitter>
} @else {
    <app-splitter [fullHeight]="true">
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="leftPanel"></ng-container>
        </ng-template>
    </app-splitter>
}
